import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom"
import { getApi } from '../../api/endpoints';
import ListingComponent from '../../components/ListingComponent';
import FiltersPartial from './FiltersPartial.js'

const Listing = () => {
  const defaultHeaderConfig = { disableSort: false };
  const params = useParams();
  const [filtersModel, setFiltersModel] = useState({})

  useEffect(() => {
    if(params && params.id) {
      setFiltersModel({owner_id: params.id})
    }
  }, [])

  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Zone',
      attr: 'charging_zone_name',
      disableSort: true
    },
    {
      label: 'firm_name',
      attr: 'firm_name',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Serial Number',
      attr: 'serial_no',
    },
    {
      label: 'Invenytory Code',
      attr: 'inventory_code',
      disableSort: true
    },
    {
      label: 'Charging Station Model',
      attr: 'charging_station_model',
      disableSort: true
    },
    {
      label: 'Charging Station Type',
      attr: 'charging_station_type',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Assigned At',
      attr: 'assigned_at',
    },
  ]

  return <>
    <ListingComponent
      key={'PAGES.ChargingStationsListingPage.name'}
      listingMutation={getApi('chargingStations')}
      className="charging-stations-listing-page"
      contentHeading="Charging Stations - Results"
      headers={headers}
      recordsKey="charging_stations"
      filtersModel={filtersModel}
      searchBy={['ID','Serial Number']}
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
    />
  </>
};

export default Listing;
